import React ,{ useState , useCallback, Fragment} from 'react'
import Breadcrumb from '../../components/common/breadcrumb'
import { AddTweets, TweetID, Submit, Submitting } from '../../constant'
import { ToastContainer, toast } from 'react-toastify'
import { ApiCall } from '../../api'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const AddTweet = () => {
    const navigate = useNavigate();
    const [tweet, setTweet] = useState("");
    const [Load, setLoad] = useState(false);
    const authSelector = useSelector((state) => state.Auth.authData);

    const inputElement = (event) => {
        event.persist();
        const result = event.target.value.replace(/\D/g, '');
        setTweet(result);
    }

    const submitForm = (event) => {
        event.preventDefault()
        setLoad(true);
        const data = {
            "tweetId": tweet
        }
        ApiCall(data, "POST", "add_tweets", authSelector.token, handleResponse)
    }

    const handleResponse = useCallback((response) => {
        if(response.status){
            toast.success(response.message)
            setLoad(false);
            navigate(`/twitter-feeds/list`);
        }else{
            setLoad(false);
            toast.error(response.message)
            navigate(`/twitter-feeds/add`);
        }
    },[navigate])

    return (
        <Fragment>
            <Breadcrumb   parent = "Dashboard" title = "Twitter-feeds" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                <h5>{AddTweets}</h5>
                            </div>
                            <form className="form theme-form" onSubmit={submitForm}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <div className="form-group">
                                                <label htmlFor="form-control-tweet">{TweetID}</label>
                                                <input className="form-control btn-pill" id="form-control-tweet" aria-describedby="tweetIdHelp" type="text"
                                                    value={tweet} name="tweetId" placeholder='Enter Tweet id' onChange={inputElement} />
                                                <br />
                                                <small className="form-text text-muted" id="tweetIdHelp"><b>Note:- </b>{"Please use the tweet id from twitter for i.g. https://twitter.com/username/status/142456488548855478"}</small>
                                                <br />
                                                <small className="form-text text-muted" id="tweetIdHelp"><b>Note:- </b>{"Here tweet id will be this  -  "}<b>142456488548855478</b></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer text-end">
                                    {Load ? 
                                        <button className="btn btn-primary me-2 disabled" type="button" style={{ 'display': 'inline-flex'}}>{Submitting}
                                            <div className='loader-box' style={{'height': '21px'}}>
                                            <span className="rotate dashed colored" style={{'height': '21px', 'width': '21px'}}></span>
                                            </div>
                                        </button>
                                    :                                                         
                                        <button className="btn btn-primary me-2" type="submit">{Submit}</button>
                                    }

                                    <input className="btn btn-light" type="reset" defaultValue="Cancel" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </Fragment>
    );
};

export default AddTweet;